<img class="cropped" [src]="src" *ngIf="!edition" (click)="loadImage()">

<div *ngIf="ready && editMode">
  <img-cropper [image]="data" [settings]="cropperSettings" #cropper (onCrop)="cropped($event)" *ngIf="edition"></img-cropper>
</div>



// WEBPACK FOOTER //
// ./src/app/components/picture-cropper/picture-cropper.component.html